/* eslint-disable no-unused-vars */
import { useState, useEffect, memo, useRef, useMemo } from "react";
import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
import { useSelector, useDispatch } from "react-redux";
import * as PersistItemsAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import * as sponsorshipsDataAction from "@mywvglobal-shared/mywv-shared/action/sponsorshipsDataAction";
import * as NetworkUtilities from "../../../utilities/networkUtilities.js";
import * as Locale from "@mywvglobal-shared/mywv-shared/locales";
import * as Action from "@mywvglobal-shared/mywv-shared/action/worldAction";
import SingleChildMarkerComponent from "../../organism/singleChildMarkerView.js";
import SponsorMarkerComponent from "../../organism/sponsorMarkerView.js";
import GroupChildMarkerComponent from "../../organism/groupChildMarkerView.js";
import useAlert from "../../../hooks/useAlert.js";
import { useTranslation } from "react-i18next";
import NavCarousel from "../../organism/NavCarousel";
import * as ErrorUtilities from "../../../utilities/errorUtilities";
import ApiConstants from "@mywvglobal-shared/mywv-shared/api/apiConstant";
import * as ErrorAction from "@mywvglobal-shared/mywv-shared/action/errorActions";
import AutoCompleteSearch from "../../molecule/AutoCompleteSearch/AutoCompleteSearch";
import "../../../styles/Home.css";
import { MarkerContainer } from "../../atoms/Cards";
import { Text } from "../../atoms/TextField";
import ChildSearchView from "./childSearchView";
import { AutoCompleteWrapper } from "../../atoms/Header";
import { MainWrapper, MapWrapper } from "../../atoms/Layout";
import { Error, ErrorClose } from "../../atoms/Error";
import HighlightText from "../../atoms/HighlightText";
import AlertPopup from "../../molecule/AlertPopup";
import MapShadow from "../../../images/globe-shadow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import { constants } from "../../../constants";
import CookiesPopup from "../../atoms/CookiesPopup";
import { decrypt } from "../../../utilities/tokenizer";
import Header from "../../organism/Header";
import { isMobile } from "../../../utilities/deviceUtilities";
import { encrypt } from "../../../utilities/tokenizer";
import CommonModalPopup from "../../organism/CommonModalPopup";
import {
  LeftArrowGlobe,
  RightArrowGlobe,
  WorldDataHome,
} from "../../atoms/Carousel/index.js";
import LeftArrow from "../../../images/nav_left.svg";
import RightArrow from "../../../images/nav_right.svg";
import { gaEvent } from "../../../utilities/analytics.js";
import { getCookie } from "../../../utilities/cookieUtilities";
import {
  diffYMDHMS,
  convertToLocaleDate,
} from "../../../utilities/dateUtilities";
import { logoutUser } from "../../../utilities/LogOutUtils";
import ActivityIndicator from "../../molecule/PageLoader/LoadingOverlay.js";
import WorldMapCelebrationPopup from "../../organism/ProjectCelebration/WorldMapCelebrationPopup";
import Button from "react-bootstrap/Button";
import FieldDropPopup from "../../organism/FieldDropPopup/FieldDropPopup";
import { isFieldDropEligible } from "../../../utilities/fieldDropEligibilityUtils";
import {
  SELECTED_SO_CODE_NZLO,
  SELECTED_SO_CODE_FINO,
} from "../../../constants/soCode";
import HighlightTextWithLogic from "../../molecule/HighlightTextWithLogic";
import useApiRepository from "../../../api/useApiRepository.js";
const Home = () => {
  const apiRepo = useApiRepository();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);
  const { worldReducer } = useSelector((state) => state);
  const [retryCount, setRetryCount] = useState(0);
  const [noSponsorChildError, setNoSponsorChildError] = useState(false);
  const { sponsorshipsDataReducer } = useSelector((state) => state);
  const [mapView, setMapView] = useState("default");
  const [isChildSearchVisible, setChildSearchVisible] = useState(false);
  const [childGroupList, setChildGroupList] = useState("");
  const [isFromGroup, setFromGroup] = useState(false);
  const [subRegionName, setSubRegionName] = useState("");
  const [subRegionTranslation, setSubRegionTranslation] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [cookieSettings, setCookieSettings] = useState(false);
  const [center, setCenter] = useState({
    lat: -3.745,
    lng: -38.523,
  });
  const [worldData, setWorldData] = useState(null);
  const [mapObj, setMapObject] = useState(null);
  const [sponseredChildCount, setSponseredChildCount] = useState(0);
  const [zoom, setZoom] = useState(() =>
    window?.innerWidth < 360 && window?.innerWidth < 1250 ? 3.2 : 3.2
  );
  const dispatch = useDispatch();
  const [currentMobilestationID, setCurrentMobilestationID] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [chosenList, setChosenList] = useState([]);
  const [celebrationPopup, setCelebrationPopup] = useState(false);
  const [fieldDropPopup, setFieldDropPopup] = useState(false);
  const [eligibleFieldDropChildren, setEligibleFieldDropChildren] = useState([]);
  const [eligiblePCChildren, setEligiblePCChildren] = useState([]);
  const [seenChildIds, setSeenChildIds] = useState([]);
  const [userClosedPopup, setUserClosedPopup] = useState(false);
  const [hasClosedFirstTimeModal, setHasClosedFirstTimeModal] = useState(false);
  const [hasClosedCookiesPopup, setHasClosedCookiesPopup] = useState(false);
  const sponsorName = worldReducer?.getSponsorChildCoordinates?.supporterFName;
  const chosenListArray = [];
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  });

  const { setAlert } = useAlert();
  const { t, i18n } = useTranslation();

  const containerStyle = {
    width: mapView === "globe" ? "100%" : "100vw",
    height: mapView === "globe" ? "100%" : "100vh",
    margin: "0 auto",
  };

  const styles = {
    hightlightMessage: {
      color: "white",
      fontSize: "14px",
      fontFamily: "Lato",
      marginTop: "15px",
    },
    textMessageUnderline: {
      color: "white",
      fontSize: "14px",
      fontFamily: "Lato",
      marginTop: "5px",
      marginLeft: "5px",
      textDecorationLine: "underline",
    },
  };

  const defaultMapOptions = {
    fullscreenControl: false,
    disableDefaultUI: true,
    mapTypeId: "satellite",
    keyboardShortcuts: false,
    draggable: isMobile() ? false : true,
    gestureHandling: "greedy",
    minZoom: zoom,
    maxZoom: zoom + 1,
    transformStyle: "preserve-3d",
    transform: "perspective(500px) translateZ(-30vw) scale(1.4)",
    perspective: 1000,
    restriction: {
      latLngBounds: isMobile()
        ? {
            north: 80,
            south: -60,
            east: 1600,
            west: 120,
          }
        : {
            north: 70,
            south: -60,
            east: 200,
            west: 600,
          },
    },
  };

  const [defaultOptions, setDefaultOptions] = useState(defaultMapOptions);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [loaderText, setLoaderText] = useState(null);
  const hasFetchedCoordinates = useRef(false);
  const hasFetchedSponsor = useRef(false);
  gaEvent("PageView");

  useEffect(() => {
    if (localStorage.getItem("accountPageVisited") === null) {
      localStorage.setItem("accountPageVisited", "false");
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem("userLogging");
    }, 10000);
    let intervalId = null;
    if (
      localStorage.getItem("userLogging") &&
      localStorage.getItem("userLogging") == "true"
    ) {
      intervalId = setInterval(() => {
        setLoaderText((prevText) => {
          if (persistItemsReducer?.selectedSOData?.soCode == "AUTO") {
            return prevText === localStorage.getItem("LoggingYouAUTO")
              ? localStorage.getItem("LoadingYourAccountAUTO")
              : localStorage.getItem("LoggingYouAUTO");
          } else if (persistItemsReducer?.selectedSOData?.soCode == "FINO") {
            return prevText === localStorage.getItem("LoggingYouFINO")
              ? localStorage.getItem("LoadingYourAccountFINO")
              : localStorage.getItem("LoggingYouFINO");
          } else if (persistItemsReducer?.selectedSOData?.soCode == "JPNO") {
            return prevText === localStorage.getItem("LoggingYouJPNO")
              ? localStorage.getItem("LoadingYourAccountJPNO")
              : localStorage.getItem("LoggingYouJPNO");
          } else if (persistItemsReducer?.selectedSOData?.soCode == "NZLO") {
            return localStorage.getItem("LoadingYourAccountNZ");
          }
        });
      }, 1100);
    } else {
      setTimeout(() => {
        setLoaderText(t("LoadingYourAccount"));
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [localStorage.getItem("userLogging"), i18n]);

  // Subsequent useEffect to handle world data fetching
  useEffect(() => {
    if (worldReducer?.isServiceSuccess) {
      apiRepo.getSponsorshipsData();
    }
  }, [worldReducer.isServiceSuccess]);

  useEffect(() => {
    if (
      localStorage.getItem("pathname") &&
      localStorage.getItem("pathname") != null
    ) {
      let pathname = localStorage.getItem("pathname");
      let searchparam = localStorage.getItem("searchparam")
        ? localStorage.getItem("searchparam")
        : localStorage.getItem("search");
      let childCode = decrypt(pathname.split("/")[4]); //to test in local make [4] -> [3]
      let item =
        sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships?.filter(
          (item) => {
            return item?.childCode == childCode;
          }
        );
      if (item && item.length > 0) {
        localStorage.removeItem("pathname")
        localStorage.removeItem("searchparam")
        localStorage.removeItem("search")
        if (pathname.includes("/mysponsorship")) {
          pathname = pathname.replace("/mysponsorship", "")
        }
        navigate(pathname + searchparam);
      }
    }
  }, [sponsorshipsDataReducer?.getSponsorshipsData]);

  // PC changes new code
  useEffect(() => {
    const activeSponsorships = sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships || [];
    const today = new Date();
    const eligiblePCChildren = activeSponsorships.filter(item => {
      const sponsorDate = new Date(item?.sponsorNotificationDate);
      const endDate = new Date(item?.apEstimatedEndDate);
      const isEligible = item?.isCelebrationEligible === true;
      return (
        sponsorDate.toString() !== "Invalid Date" &&
        endDate.toString() !== "Invalid Date" &&
        today >= sponsorDate &&
        today <= endDate &&
        isEligible
      );
    });
    const seen = getSeenChildren();
    const filteredEligibleChildren = eligiblePCChildren.filter(
      child => !seen.includes(child.childCode)
    );
    setEligiblePCChildren(filteredEligibleChildren);
  }, [sponsorshipsDataReducer?.getSponsorshipsData]);

  const getSeenChildren = () => {
    try {
      const seen = localStorage.getItem("seenCelebrationChildren");
      return Array.isArray(JSON.parse(seen)) ? JSON.parse(seen) : [];
    } catch (e) {
      return [];
    }
  };
  const addSeenChildren = (newChildIds) => {
    const seen = getSeenChildren();
    const updated = Array.from(new Set([...seen, ...newChildIds]));
    localStorage.setItem("seenCelebrationChildren", JSON.stringify(updated));
  };
  const seenChildIdsRef = useRef([]);
  const handleSeenChildrenChange = (ids) => {
    seenChildIdsRef.current = ids;
  };
  const handleCelebrationClick = () => {
    addSeenChildren(seenChildIdsRef.current);
    setCelebrationPopup(false);
    setUserClosedPopup(true);
  };
  useEffect(() => {
    if (eligiblePCChildren.length > 0) {
      const seen = getSeenChildren();
      const unseenChildren = eligiblePCChildren.filter(
        (child) => !seen.includes(child.childCode)
      );
      if (unseenChildren.length > 0) {
        setCelebrationPopup(true);
        setSeenChildIds(unseenChildren.map((child) => child.childCode));
      }
    }
  }, [eligiblePCChildren]);

  const handleSponsorNew = () => {
    localStorage.setItem("firstTime", "NO");
    dispatch(PersistItemsAction.setFirstTimeLoginStatus(false));
    setCookieSettings(true);
    gaEvent("CookieSettingsSubmit", persistItemsReducer);
    gaEvent("IUnderstandBtn", persistItemsReducer);
  };

  const handleCookieSettings = () => {
    setCookieSettings(false);
    setHasClosedCookiesPopup(true);
    gaEvent("CookieSettingsSubmit", persistItemsReducer);
  };

  const crosshandler = async () => {
    await logoutUser({
      persistItemsReducer,
      loginReducer,
      dispatch,
      LogoutAction,
      constants,
      delay,
    });
  };

  //FieldDrop code
  const getSeenFieldDropChildren = () => {
    try {
      const seen = localStorage.getItem("seenFieldDropChildren");
      return Array.isArray(JSON.parse(seen)) ? JSON.parse(seen) : [];
    } catch (e) {
      return [];
    }
  };
  const addSeenFieldDropChildren = (newChildIds) => {
    const seen = getSeenFieldDropChildren();
    const updated = Array.from(new Set([...seen, ...newChildIds]));
    localStorage.setItem("seenFieldDropChildren", JSON.stringify(updated));
  };
  const sortEligibleChildren = (children) => {
    return children.sort((childA, childB) => {
      const endDateA = new Date(
        childA.childValues?.droppedChildDetails?.childSponsorshipEndDate
      );
      const endDateB = new Date(
        childB.childValues?.droppedChildDetails?.childSponsorshipEndDate
      );
      if (endDateA.getTime() !== endDateB.getTime()) {
        return endDateA - endDateB;
      }
      const nameA = childA.childValues?.childName?.toLowerCase() || "";
      const nameB = childB.childValues?.childName?.toLowerCase() || "";
      return nameA.localeCompare(nameB);
    });
  };
  const handlePopupClose = () => {
    const seenIds = eligibleFieldDropChildren.map(
      (child) => child.childValues?.droppedChildDetails?.childCode
    );
    addSeenFieldDropChildren(seenIds);
    setFieldDropPopup(false);
  };
  const seenChildren = useMemo(() => getSeenFieldDropChildren(), [worldData]);

  useEffect(() => {
    if (Array.isArray(worldData) && worldData.length > 0) {
      const soCode = persistItemsReducer?.selectedSOData?.soCode;
      const fdNumberofDays = loginReducer?.getSOConfiguration?.fdNumberofDays;
     
    const eligibleFieldDropChildren = worldData?.map((childItem) => {
    const children = Array.isArray(childItem.childValues)? childItem.childValues: [childItem.childValues]
    const filtered = children?.filter((child) => {
      const isEligible = isFieldDropEligible(child, soCode, fdNumberofDays);
      const childId = child?.droppedChildDetails?.childCode;
      return (
        isEligible &&
        typeof childId === "string" &&
        !seenChildren.includes(childId)
      );
    });
    return filtered?.length ? filtered : null;
    })?.filter(Boolean) // remove nulls (i.e., items with no eligible children)
    .flat(); // combine all arrays into ones
      const sortedChildren = sortEligibleChildren(eligibleFieldDropChildren);
      if (sortedChildren.length > 0) {
        setEligibleFieldDropChildren(sortedChildren);
        setFieldDropPopup(true);
      }
    }
  }, [worldData, seenChildren, persistItemsReducer, loginReducer]);

  useEffect(() => {
    Locale.setLanguage(
      persistItemsReducer?.selectedSOData?.soLanguageCultureCode
    );
    if (
      loginReducer?.getSOConfiguration?.soBaseUrl &&
      hasFetchedCoordinates.current === false &&
      persistItemsReducer?.accessToken &&
      persistItemsReducer?.sponsorID &&
      persistItemsReducer?.emailID &&
      persistItemsReducer?.selectedSOData?.soLanguageCultureCode
    ) {
      hasFetchedCoordinates.current = true;
      apiRepo.getSponsorChildCoordinates();
    }
  }, [
    loginReducer?.getSOConfiguration?.soBaseUrl,
    persistItemsReducer?.sponsorID,
    persistItemsReducer?.emailID,
    persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    persistItemsReducer?.accessToken,
  ]);
  useEffect(() => {
    if (worldData && worldData.length > 0) {
      const IsChildAvaialble = worldData.some((e) => e?.isSponsor == false);
      const selectedSOCode = persistItemsReducer?.selectedSOData?.soCode;
      const isJapan = selectedSOCode === "JPNO";
      if (!IsChildAvaialble) {
        if (isJapan) {
          setAlert(
            t("NoCurrentSponsorship"),
            " ",
            t("ApplyForNewChild", {
              link: t("ApplyForNewChildLinkText"),
            }),
            [t("ApplyForNewChildLinkText")],
            "info",
            false,
            false,
            false
          );
        } else {
          setAlert(
            t("NoSponsorshipsFound"),
            t("NoSponsorshipDescription"),
            t("NoSponsorshipDescription2", {
              AccountDetails: t("AccountDetails"),
              FindNewChild: t("FindNewChild"),
            }),
            [t("AccountDetails"), t("FindNewChild")],
            "error",
            false,
            false,
            false,
            retryButtonClicked
          );
        }
      } else {
        const currentChildId =
          getCookie("currentChild") && getCookie("currentChild") !== "0"
            ? decrypt(getCookie("currentChild"))
            : 0;
        let currentIndex = 0;
        if (
          currentChildId !== null &&
          currentChildId !== "" &&
          currentChildId !== 0
        ) {
          currentIndex = worldData?.findIndex((item) => {
            if (
              (Array.isArray(item?.childValues) &&
                item?.childValues?.find(
                  (i) =>
                    i?.childCode === currentChildId ||
                    i?.chosenCorrelationID === currentChildId
                ) &&
                item?.childValues?.find(
                  (i) =>
                    (i?.childCode === currentChildId ||
                      i?.chosenCorrelationID === currentChildId) !== ""
                )) ||
              item?.childValues?.childCode === currentChildId ||
              item?.childValues?.chosenCorrelationID === currentChildId
            ) {
              return true;
            }
          });
          worldData[currentIndex] &&
            setCenter({
              lat: worldData[currentIndex]?.latitude,
              lng: worldData[currentIndex]?.longitude,
            });
          const newMapObj =
            worldData[currentIndex] && !worldData[currentIndex].isSponsor
              ? worldData[currentIndex]
              : worldData[0];
          setMapObject(newMapObj);
          setTimeout(() => {
            setCurrentMobilestationID(currentIndex);
          }, 100);
        } else if (currentChildId === 0) {
          currentIndex = worldData?.findIndex((item) => item?.isSponsor);
          worldData[currentIndex] &&
            setCenter({
              lat: worldData[currentIndex]?.latitude,
              lng: worldData[currentIndex]?.longitude,
            });
          const newMapObj =
            worldData[currentIndex] && !worldData[currentIndex].isSponsor
              ? worldData[currentIndex]
              : worldData[0];
          setMapObject(newMapObj);
          setTimeout(() => {
            setCurrentMobilestationID(currentIndex);
          }, 100);
        } else {
          worldData[0] &&
            setCenter({
              lat: worldData[0]?.latitude,
              lng: worldData[0]?.longitude,
            });
          const newMapObj =
            worldData[1] && !worldData[1].isSponsor
              ? worldData[1]
              : worldData[0];
          setMapObject(newMapObj);
        }
      }
    }
    return () => {};
  }, [worldData, getCookie("currentChild")]);

  useEffect(() => {
    if (worldReducer?.getSponsorChildCoordinates?.donorID) {
      const worldDataValues = [];
      let localChildList = [];
      const sponsorData = {
        id: worldDataValues.length + 1,
        isSponsor: true,
        latitude: parseFloat(
          worldReducer?.getSponsorChildCoordinates?.supporterLatitude
        ),
        longitude: parseFloat(
          worldReducer?.getSponsorChildCoordinates?.supporterLongitude
        ),
        image:
          worldReducer?.getSponsorChildCoordinates?.supporterProfilePictureURL,
      };
      if (worldReducer?.getSponsorChildCoordinates?.supporterEmail) {
        const param = {
          sponsorEmail:
            worldReducer?.getSponsorChildCoordinates?.supporterEmail,
        };
        dispatch(PersistItemsAction.saveSponsorEmailPersist(param));
      }
      if (sponsorData && sponsorData.latitude && sponsorData.longitude) {
        worldDataValues.push(sponsorData);
      }
      worldReducer?.getSponsorChildCoordinates?.regions?.forEach(
        (regionData) => {
          regionData?.subRegions?.forEach((subRegionsData) => {
            const subRegionWiseData = [];
            subRegionsData?.countries?.forEach((countriesData) => {
              countriesData?.communities?.forEach((communitiesData) => {
                communitiesData?.sponsoredChildren?.forEach(
                  (sponsoredChildrenData) => {
                    let commLat = countriesData?.countryLatitude;
                    let commLong = countriesData?.countryLongitude;
                    if (
                      communitiesData?.communityLatitude &&
                      communitiesData?.communityLongitude
                    ) {
                      commLat = communitiesData?.communityLatitude;
                      commLong = communitiesData?.communityLongitude;
                    }
                    const childData = {
                      latitude: commLat,
                      longitude: commLong,
                      childDataValues: sponsoredChildrenData,
                      projectName: communitiesData?.projectName,
                      countryName: countriesData?.countryName,
                      communityName: communitiesData?.communityName,
                    };
                    if (sponsoredChildrenData) {
                      sponsoredChildrenData.projectName =
                        communitiesData?.projectName;
                      sponsoredChildrenData.countryName =
                        countriesData?.countryName;
                      localChildList.push(sponsoredChildrenData);
                    }
                    subRegionWiseData.push(childData);
                  }
                );

                /* Chosen children logic start */

                communitiesData?.chosenChildren?.forEach(
                  (chosenChildrenData) => {
                    let commLat = countriesData?.countryLatitude;
                    let commLong = countriesData?.countryLongitude;

                    if (
                      communitiesData?.communityLatitude &&
                      communitiesData?.communityLongitude
                    ) {
                      commLat = communitiesData?.communityLatitude;
                      commLong = communitiesData?.communityLongitude;
                    }
                    const childData = {
                      latitude: commLat,
                      longitude: commLong,
                      childDataValues: chosenChildrenData,
                      projectName: communitiesData?.projectName,
                      countryName: countriesData?.countryName,
                      communityName: communitiesData?.communityName,
                    };
                    if (chosenChildrenData) {
                      chosenChildrenData.projectName =
                        communitiesData?.projectName;
                      chosenChildrenData.countryName =
                        countriesData?.countryName;
                      (chosenChildrenData.hasUpdate = false),
                        (chosenChildrenData.latestUpdateDate = ""),
                        (chosenChildrenData.sponsorshipStartDate = ""),
                        (chosenChildrenData.childFirstName = "NEW Chosen");
                      localChildList.push(chosenChildrenData);
                      chosenListArray.push(chosenChildrenData);
                    }
                    subRegionWiseData.push(childData);
                  }
                );
                /* Chosen children logic end */
              });
            });

            setChosenList(chosenListArray);
            if (subRegionWiseData?.length > 1) {
              let childArray = [];
              subRegionWiseData?.forEach((subRegionWiseDataValue) => {
                childArray.push(subRegionWiseDataValue?.childDataValues);
              });
              childArray = childArray.sort((a, b) => {
                const c = new Date(a?.sponsorshipStartDate);
                const d = new Date(b?.sponsorshipStartDate);
                return c - d;
              });
              childArray = childArray.sort((a, b) => {
                const c = new Date(a?.latestUpdateDate);
                const d = new Date(b?.latestUpdateDate);
                return c - d;
              });
              childArray = childArray.sort((a, b) => b.hasUpdate - a.hasUpdate);

              childArray = childArray.sort((a, b) => {
                const c = new Date(a?.revealDate ?? "01/01/2099");
                const d = new Date(b?.revealDate ?? "01/01/2099");
                return c - d;
              });

              const subRegionWiseFilteredData = {
                id: worldDataValues.length + 1,
                isSponsor: false,
                latitude: parseFloat(subRegionsData?.subRegionLatitude),
                longitude: parseFloat(subRegionsData?.subRegionLongitude),
                childValues: childArray,
                subRegionName: regionData?.regionName,
                childProjectCountry: `${subRegionWiseData[0]?.projectName}, ${subRegionWiseData[0]?.countryName}`,
                countryName: subRegionWiseData[0]?.countryName,
                communityName: subRegionWiseData[0]?.communityName,
              };
              if (
                subRegionWiseFilteredData &&
                subRegionWiseFilteredData.latitude &&
                subRegionWiseFilteredData.longitude
              ) {
                worldDataValues.push(subRegionWiseFilteredData);
              }
            } else {
              const subRegionWiseFilteredData = {
                id: worldDataValues.length + 1,
                isSponsor: false,
                latitude: parseFloat(subRegionWiseData[0]?.latitude),
                longitude: parseFloat(subRegionWiseData[0]?.longitude),
                childValues: subRegionWiseData[0]?.childDataValues,
                childProjectCountry: `${subRegionWiseData[0]?.projectName}, ${subRegionWiseData[0]?.countryName}`,
                communityName: subRegionWiseData[0]?.communityName,
                countryName: subRegionWiseData[0]?.countryName,
              };
              if (
                subRegionWiseFilteredData &&
                subRegionWiseFilteredData.latitude &&
                subRegionWiseFilteredData.longitude
              ) {
                worldDataValues.push(subRegionWiseFilteredData);
              }
            }
          });
        }
      );
      if (worldDataValues && worldDataValues.length > 0) {
        worldDataValues.sort((item1, item2) => item1.latitude - item2.latitude);
        worldDataValues.sort(
          (item1, item2) => item1.longitude - item2.longitude
        );
        if (localChildList && localChildList.length > 0) {
          localChildList = localChildList.sort((a, b) => {
            const c = new Date(a?.revealDate ?? "01/01/2099");
            const d = new Date(b?.revealDate ?? "01/01/2099");
            return c - d;
          });
          localChildList = localChildList.sort((a, b) => {
            const c = new Date(a?.sponsorshipStartDate);
            const d = new Date(b?.sponsorshipStartDate);
            return c - d;
          });
          localChildList = localChildList.sort((a, b) => {
            const c = new Date(a?.latestUpdateDate);
            const d = new Date(b?.latestUpdateDate);
            return c - d;
          });
          localChildList = localChildList.sort(
            (a, b) => b.hasUpdate - a.hasUpdate
          );

          const param = {
            childList: localChildList,
          };
          dispatch(Action.saveChildList(param));
        }
        setWorldData(worldDataValues);
        let count = worldDataValues.filter(
          (data) => !data.isSponsor && !data.chosenCorrelationID
        ).length;
        setSponseredChildCount(count);
      }
    }
  }, [worldReducer?.getSponsorChildCoordinates?.donorID]);
  useEffect(() => {
    if (worldReducer?.getSponsorChildCoordinates?.donorID) {
      if (
        window.cioanalytics &&
        typeof window.cioanalytics.identify === "function"
      ) {
        window.cioanalytics.ready(() => {
          window.cioanalytics.identify(
            worldReducer?.getSponsorChildCoordinates?.donorID,
            {
              email: worldReducer?.getSponsorChildCoordinates?.supporterEmail,
              first_name:
                worldReducer?.getSponsorChildCoordinates?.supporterFName,
              last_name:
                worldReducer?.getSponsorChildCoordinates?.supporterLName,
            }
          );
        });
      }
    }
  }, [worldReducer?.getSponsorChildCoordinates?.donorID]);

  async function handleUnauthorizedTokenError() {
    await logoutUser({
      persistItemsReducer,
      loginReducer,
      dispatch,
      LogoutAction,
      constants,
      delay,
    });
  }

  useEffect(() => {
    // if token is expired or unauthorized, logout user
    if (worldReducer.errorMessage?.status === 401) {
      handleUnauthorizedTokenError();
      return;
    }
    if (worldReducer?.errorMessage?.status) {
      setAlert(
        t("Warning"),
        t("GenericError"),
        "",
        "",
        "error",
        false,
        false,
        true,
        (n) => retryButtonClicked(n)
      );
    }
    if (
      worldReducer?.getSponsorChildCoordinates != null &&
      Object.keys(worldReducer?.getSponsorChildCoordinates).length > 0 &&
      worldReducer?.getSponsorChildCoordinates?.regions == null
    ) {
      setNoSponsorChildError(true);
    }
  }, [
    worldReducer?.errorMessage?.status,
    worldReducer?.getSponsorChildCoordinates,
  ]);

  const retryButtonClicked = (n) => {
    if (n == 3) {
      crosshandler();
    }
    if (retryCount < 2) {
      setRetryCount((retryCount) => retryCount + 1);
      apiRepo.getSponsorChildCoordinates();
    } else {
      setRetryCount(0);
      setAlert(
        "Warning",
        t("GenericError"),
        "",
        "",
        "error",
        false,
        false,
        false
      );
      const request = ErrorUtilities.sendErrorEmail(
        loginReducer?.getSOConfiguration,
        persistItemsReducer,
        worldReducer?.errorMessage,
        ApiConstants.GET_SPONSOR_AND_CHILD_DATA
      );
      if (request) {
        dispatch(ErrorAction.sendErrorReportRequest(request));
      }
      crosshandler();
    }
  };

  const onLoadMarkers = (marker) => {
    if (marker?.childValues) {
      if (marker?.childValues.length > 1) {
        const groupDataWithCelebration = marker.childValues.map((child) => ({
          ...child,
        }));
        return (
          <GroupChildMarkerComponent
            groupData={groupDataWithCelebration}
            subRegionName={marker?.subRegionName}
            searchData={worldData}
          />
        );
      }
      const singleChild = marker.childValues[0] || marker.childValues;
      return (
        <SingleChildMarkerComponent
          childValue={{ ...singleChild }}
          communityName={marker?.communityName}
          countryName={marker?.countryName}
          childProjectCountry={marker?.childProjectCountry}
          searchData={worldData}
        />
      );
    }
    if (marker?.isSponsor && marker?.latitude && marker?.longitude) {
      return (
        <SponsorMarkerComponent
          {...marker}
          sponsorID={persistItemsReducer?.sponsorID}
          soCode={persistItemsReducer?.selectedSOData?.soCode}
          baseURL={worldReducer?.getSponsorChildCoordinates?.appBaseURL}
          handleRedirect={handleRedirect}
        />
      );
    }
    return null;
  };

  const handleRedirect = () => {
    setOpenModal(!openModal);
    navigate("/myaccount", { state: { navigateFrom: "home" } });
  };

  const carouselClickHandler = (mapObj, index) => {
    setCurrentMobilestationID(index);
    setMapObject(mapObj);
    setCenter({
      lat: mapObj?.latitude,
      lng: mapObj?.longitude,
    });
  };

  const handleCloseClick = () => {
    if (worldReducer?.getSponsorChildCoordinates?.sponsoredChildrenCount > 0) {
      if (worldData.length === 1 && worldData[0]?.isSponsor) {
        navigate("/myaccount");
      } else if (chosenList && chosenList.length > 0) {
        worldData.slice(0, 2).map((item) => {
          if (item?.isSponsor == false && !item?.chosenCorrelationID) {
            const newChildValues = Array.isArray(item?.childValues)
              ? item?.childValues?.filter(
                  (child) => !child?.chosenCorrelationID
                )
              : item?.childValues;
            if (newChildValues?.length > 0) {
              navigate(
                `/communityhomeview/${encrypt(newChildValues[0]?.childCode)}`
              );
            } else if (!newChildValues?.chosenCorrelationID) {
              navigate(
                `/communityhomeview/${encrypt(newChildValues?.childCode)}`
              );
            }
          }
        });
      } else if (isMobile()) {
        if (mapObj?.isSponsor) {
          navigate("/myaccount");
        } else if (mapObj?.childValues?.length > 1) {
          navigate(
            `/communityhomeview/${encrypt(mapObj?.childValues[0]?.childCode)}`
          );
        } else {
          navigate(
            `/communityhomeview/${encrypt(mapObj?.childValues?.childCode)}`
          );
        }
      } else {
        if (location?.state?.selectedChild) {
          navigate(`/communityhomeview/${location?.state?.selectedChild}`);
        } else {
          worldData.slice(0, 2).map((item) => {
            if (item?.isSponsor == false) {
              if (item?.childValues?.length > 1) {
                navigate(
                  `/communityhomeview/${encrypt(
                    item?.childValues[0]?.childCode
                  )}`
                );
              } else {
                navigate(
                  `/communityhomeview/${encrypt(item?.childValues?.childCode)}`
                );
              }
            }
          });
        }
      }
    } else {
      chosenList?.sort(function (a, b) {
        return new Date(a.revealDate) - new Date(b.revealDate);
      });
      if (
        chosenList &&
        chosenList.length > 0 &&
        chosenList[0]?.chosenCorrelationID
      ) {
        const diffObj = diffYMDHMS(
          convertToLocaleDate(
            chosenList[0]?.revealDate?.replace(
              "12:00:00 AM",
              "7:00:00 PM GMT+13"
            )
          ),
          convertToLocaleDate()
        );
        if (diffObj?.days < 0) {
          navigate("/chosen-children/");
        } else {
          navigate(`/chosen-layout/${chosenList[0]?.chosenCorrelationID}`);
        }
      }
    }
  };

  useEffect(() => {
    if (mapView === "globe") {
      setZoom(4);
    }
    if (zoom === 5) {
      childChangeHandler({ latitude: center.lat, longitude: center.lng }, true);
    } else if (zoom > 5) {
      childChangeHandler({ latitude: center.lat, longitude: center.lng }, true);
    }
  }, [zoom, setZoom]);

  const childChangeHandler = (mapObj, doZoom) => {
    setCenter({
      lat: mapObj?.latitude,
      lng: mapObj?.longitude,
    });
    doZoom ? "" : setZoom((zoom) => (zoom < 5 ? 5 : zoom + 2));
    setDefaultOptions({ ...defaultMapOptions, minZoom: 3, maxZoom: 5 });
    setMapView("default");
  };

  const deSelectChild = () => {
    setCenter({
      lat: -3.745,
      lng: -38.523,
    });
    let zoom = 2.4;
    setDefaultOptions({
      ...defaultMapOptions,
      minZoom: zoom,
      maxZoom: zoom + 1,
    });
    setZoom(zoom);
  };

  const setChildSearchModalVisibility = () => {
    setChildSearchVisible(!isChildSearchVisible);
  };

  const onMarkerClick = (marker) => {
    if (marker?.childValues && marker?.childValues.length > 1) {
      const sortedChildValues = [...marker.childValues].sort((a, b) => {
        const aIsCelebration = a.isCelebrationEligible || false;
        const bIsCelebration = b.isCelebrationEligible || false;
        const aIsChosen = !!a.chosenCorrelationID;
        const bIsChosen = !!b.chosenCorrelationID;
        return (
          bIsCelebration - aIsCelebration ||
          bIsChosen - aIsChosen ||
          new Date(a.sponsorshipStartDate) - new Date(b.sponsorshipStartDate) ||
          b.hasUpdate - a.hasUpdate
        );
      });
      const groupDataWithCelebration = sortedChildValues.map((child) => ({
        ...child,
      }));
      setChildGroupList(groupDataWithCelebration);
      setSubRegionName(marker?.subRegionName);
      setSubRegionTranslation(
        loginReducer?.getSOConfiguration?.regionNameTranslations?.filter(
          (translations) => {
            return translations?.region == marker?.subRegionName;
          }
        )
      );
      setFromGroup(true);
      setChildSearchVisible(true);
    } else if (marker?.childValues) {
      const param = {
        selectedChildValues: marker?.childValues,
      };
      dispatch(Action.saveChildDetails(param));
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setNoSponsorChildError(false);
  };

  const minSwipeDistance = 50;
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe || isRightSwipe) {
      isLeftSwipe && currentMobilestationID < worldData?.length - 1
        ? setCurrentMobilestationID(
            (currentMobilestationID) => currentMobilestationID + 1
          )
        : isRightSwipe && currentMobilestationID > 0
        ? setCurrentMobilestationID(
            (currentMobilestationID) => currentMobilestationID - 1
          )
        : setCurrentMobilestationID(
            (currentMobilestationID) => currentMobilestationID
          );
    }
  };

  const errorViewDes = () => {
    return (
      <HighlightTextWithLogic
        textToHighlight={
          persistItemsReducer?.selectedSOData?.soCode == "JPNO"
            ? t("ApplyForNewChild", { link: t("ApplyForNewChildLinkText") })
            : t("NoSponsorshipDescription2", {
                AccountDetails: t("AccountDetails"),
                FindNewChild: t("FindNewChild"),
              })
        }
        searchWords={[
          t("AccountDetails"),
          t("FindNewChild"),
          t("ApplyForNewChildLinkText"),
        ]}
        textstyle={styles.hightlightMessage}
        highlightstyle={styles.textMessageUnderline}
        setNoSponsorChildError={setNoSponsorChildError}
      />
    );
  };
  const onNavigateToDropChildStation = (childCode) => {
    navigate(`/drop-child-profile/${encrypt(childCode)}`);
  };

  return isLoaded ? (
    <MainWrapper>
      {worldReducer?.loading ? (
        <div style={{ height: "100vh" }}>
          <ActivityIndicator loaderText={loaderText || t("Pleasewait")} />
        </div>
      ) : (
        <>
          <MapWrapper className="worldMap">
            <Header
              world
              handleCloseClick={worldData?.length > 0 ? handleCloseClick : ""}
            >
              {worldReducer?.childList?.length > 0 && (
                <AutoCompleteWrapper worldHeader>
                  <AutoCompleteSearch
                    worldHeader
                    suggestions={worldData}
                    searchBy="name"
                    display="displayValue"
                    childChange={childChangeHandler}
                    deSelectChild={deSelectChild}
                  />
                </AutoCompleteWrapper>
              )}
            </Header>

            {worldData && (
              <WorldDataHome>
                {isMobile(740) && (
                  <LeftArrowGlobe
                    src={LeftArrow}
                    enabled={currentMobilestationID > 0}
                    onClick={() =>
                      currentMobilestationID > 0 &&
                      setCurrentMobilestationID(currentMobilestationID - 1)
                    }
                    alt=""
                  />
                )}
                {isMobile(740) && (
                  <RightArrowGlobe
                    src={RightArrow}
                    enabled={currentMobilestationID < worldData?.length - 1}
                    onClick={() =>
                      currentMobilestationID < worldData?.length - 1 &&
                      setCurrentMobilestationID(currentMobilestationID + 1)
                    }
                    alt=""
                  />
                )}
                <NavCarousel
                  initialSlide={1}
                  mapView={mapView}
                  contentArray={worldData}
                  carouselClickHandler={carouselClickHandler}
                  currentMobilestationID={currentMobilestationID}
                />
              </WorldDataHome>
            )}
            <section className={mapView === "globe" ? "stage" : ""}>
              <figure
                className={mapView === "globe" ? "ball" : ""}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
              >
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  backgroundColor={"#00080"}
                  options={defaultOptions}
                  id="map"
                >
                  {worldData?.map((marker) => (
                    <OverlayView
                      key={marker.id}
                      position={{
                        lat: marker.latitude,
                        lng: marker.longitude,
                      }}
                      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                      <MarkerContainer onClick={() => onMarkerClick(marker)}>
                        {onLoadMarkers(marker)}
                      </MarkerContainer>
                    </OverlayView>
                  ))}
                </GoogleMap>
              </figure>
              <span className="shadow">
                <img src={MapShadow} className="globe-shadow" alt="" />
              </span>
            </section>
          </MapWrapper>

          <ChildSearchView
            isVisible={isChildSearchVisible}
            setVisibility={setChildSearchModalVisibility}
            childGroupList={childGroupList}
            subRegionName={
              persistItemsReducer?.selectedSOData?.soCode?.toLowerCase() ===
              "nzlo"
                ? subRegionName
                : subRegionTranslation[0]?.translation
            }
            isFromGroup={isFromGroup}
            searchData={worldData}
          />

          {sponseredChildCount > 0 && isMobile(740) && (
            <Text homedisclaimer>{t("ChooseAChild")}</Text>
          )}

          {noSponsorChildError ? (
            <Error>
              <h2>
                <span>
                  {persistItemsReducer?.selectedSOData?.soCode == "JPNO"
                    ? t("NoCurrentSponsorship")
                    : t("NoSponsorshipsFound")}{" "}
                </span>
              </h2>
              {persistItemsReducer?.selectedSOData?.soCode == "JPNO" ? (
                ""
              ) : (
                <p>{t("NoSponsorshipDescription")}</p>
              )}
              {errorViewDes()}
              <ErrorClose onClick={handleClick} href="/" />
            </Error>
          ) : null}
          {persistItemsReducer?.isFirstTimeLoggedIn && (
            <CommonModalPopup
              logout
              type="warning"
              show={true}
              title={t("privacyNotice")}
              body={t("privacyBodyHome")}
              confirm={{
                title: t("understood"),
                handler: () => {
                  handleSponsorNew();
                  setHasClosedFirstTimeModal(true);
                },
              }}
              close={{
                handler: () => {
                  crosshandler();
                  gaEvent(
                    "PrivacyPolicy_AfterLoginCloseBtn",
                    persistItemsReducer
                  );
                  setHasClosedFirstTimeModal(true);
                },
              }}
              cancel={{
                title: t("PrivacyPolicy"),
                autoclose: false,
                handler: () => {
                  (function () {
                    window.open(
                      loginReducer?.getSOConfiguration?.privacyStatementLink,
                      "_blank"
                    );
                    window.focus();
                  })();
                },
              }}
            />
          )}
          {cookieSettings && (
            <CookiesPopup
              show={cookieSettings}
              closeBtnClick={handleCookieSettings}
            />
          )}
          <AlertPopup />
          {celebrationPopup &&
            persistItemsReducer?.selectedSOData?.soCode == "NZLO" &&
            (!persistItemsReducer?.isFirstTimeLoggedIn ||
              hasClosedFirstTimeModal) &&
            (!cookieSettings || hasClosedCookiesPopup) && (
              <WorldMapCelebrationPopup
                show={celebrationPopup}
                onHide={handleCelebrationClick}
                celebrationProjects={eligiblePCChildren}
                onSeenChildrenChange={handleSeenChildrenChange}
              />
            )}

          {fieldDropPopup &&
            [SELECTED_SO_CODE_FINO, SELECTED_SO_CODE_NZLO].includes(
              persistItemsReducer?.selectedSOData?.soCode
            ) &&
            (!persistItemsReducer?.isFirstTimeLoggedIn ||
              hasClosedFirstTimeModal) &&
            (!cookieSettings || hasClosedCookiesPopup) &&
            !celebrationPopup && (
              <FieldDropPopup
                show={fieldDropPopup}
                onHide={handlePopupClose}
                data={eligibleFieldDropChildren}
                onNavigate={onNavigateToDropChildStation}
                sponsorName={sponsorName}
              />
            )}
        </>
      )}
    </MainWrapper>
  ) : (
    <div style={{ height: "100vh" }}>
      <ActivityIndicator loaderText={loaderText || t("Pleasewait")} />
    </div>
  );
};

export default memo(Home);
